
document.addEventListener("DOMContentLoaded", function() {
  const shopSwiper = document.querySelector('.shop-swiper');
  if (shopSwiper) {
    new Swiper('.shop-swiper', {
      slidesPerView: 6,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: '.shop-swiper .swiper-button-next',
        prevEl: '.shop-swiper .swiper-button-prev',
      },
      pagination: false,
      breakpoints: {
        0:    { slidesPerView: 2 },
        550:  { slidesPerView: 2 },
        768:  { slidesPerView: 2 },
        1024: { slidesPerView: 5 },
        1440: { slidesPerView: 5 },
        1600: { slidesPerView: 6 }
      }
    });
  }
  $(".drawer-shop-grid").owlCarousel({
    loop: true,
    margin: 15,
    nav: true,
    dots: false,
  
    autoplay: false,
    autoplayTimeout: 2500,   // 2.5 sec per slide
    autoplaySpeed: 800,      // smooth transition
    autoplayHoverPause: true, // stop on mouse hover
  
    responsive: {
      0: {
        items: 2
      },
      480: {
        items: 2
      },
      768: {
        items: 3
      },
      1024: {
        items: 2
      }
    }
  });
});



